<template>
  <div
    v-if="item"
    class="main__light_green rounded-lg pa-6 width-100"
    :data-qa="dataQa">
    <div
      class="mb-4 max-width-100"
      style="display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 16px;">
      <div class="text-left max-width-100">
        <div
          class="pb-1 text-start">
          <router-link
            v-if="item && item.id"
            class="max-width-100  h3-headline"
            :data-qa="dataQa + '-href-title'"
            :to="{name: 'groupOfAccreditationsItem', params: { id: item.id, org: $route.params.org }}">
            <TooltipedText
              :line-count="3"
              :value="item.title"/>
          </router-link>
          <div
            v-else
            class="h3-headline"
            :data-qa="dataQa + '-title'">
            <TooltipedText
              :line-count="3"
              :value="item.title ? item.title : '-'"/>
          </div>

          <TooltipedText
            v-if="item.description"
            :data-qa="dataQa + '-description'"
            :line-count="1"
            :line-height="1.15"
            :value="item.description"/>
        </div>
      </div>
      <div class="flex">
        <StatusChip
          class="mt-1 mr-1"
          :data-qa="dataQa + '-status'"
          key-name="id"
          :name="$t(`groupOfAccreditation.status.${item.status}`)"
          :status="item.status"
          text-color="var(--color-black)"
          value-name="title"/>
        <GroupOfAccreditationMenu
          v-if="item && item.id"
          :data-qa="dataQa + '-menu'"
          :item="item ? item : {}"
          @deactivate="onDeactivate"
          @publish="onPublish"/>
      </div>
    </div>
    <div
      class="flex flex-between gap-10"
      data-qa="block-dates">
      <div 
        class="flex gap-10">
        <KeyDate
          :caption="$t('Tenders.PublicationDate')"
          class="mr-6"
          :data-qa="dataQa + '-publicationDate'"
          :value="item.datePublish"/>
        <KeyDate
          :caption="$t('Tenders.DateOfCreation')"
          class="mr-6"
          :data-qa="dataQa + '-creationDate'"
          :value="item.created ? item.created.date : null"/>
        <KeyDate
          :caption="$t('Дата редагування')"
          :data-qa="dataQa + '-modificationDate'"
          :value="item.modified ? item.modified.date : null"/>  
      </div>
      <div>
        <div
          v-if="item.suppliersRequestStatistics && item.suppliersRequestStatistics.length"
          class="flex gap-6 mb-2">
          <sIcon
            type="person"/>
          <GroupOfAccreditationStateChips :items="item.suppliersRequestStatistics"/>
        </div>
        <div
          v-if="item && item.id"
          class="flex gap-6">
          <sTooltip
            :border="false"
            :content="$t('Tenders.Categories') | firstUpperCase"
            :open-delay="300"
            placement="bottom"
            type="white">
            <IconCount
              class="mt-auto mr-0"
              :count="item.categoriesCount"
              icon="category"
              :icon-color="!item.categoriesCount ? 'grey': ''"
              :text-class="{ 'grey--text': !item.categoriesCount }"/>
          </sTooltip>
          <sTooltip
            :border="false"
            :content="$t('Tenders.Files')"
            :open-delay="300"
            placement="bottom"
            type="white">
            <IconCount
              class="mt-auto mr-0"
              :count="item.filesCount"
              icon="draft"
              :icon-color="!item.filesCount ? 'grey': ''"
              :text-class="{ 'grey--text': !item.filesCount }"/>
          </sTooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KeyDate from 'components/common/KeyDate.vue'
import IconCount from 'components/common/elements/IconCount.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import GroupOfAccreditationMenu from 'components/group of accreditations/GroupOfAccreditationMenu.vue'
import GroupOfAccreditationStateChips from 'components/group of accreditations/GroupOfAccreditationStateChips.vue'

export default {
  name: 'groupOfAccreditationCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    dataQa: {
      type: String,
      default: 'group-of-accreditation-card'
    }
  },
  methods: {
    onPublish() {
      this.$emit('publish', this.item?.id)
    },
    onDeactivate() {
      this.$emit('deactivate', this.item?.id)
    }
  },
  components: {
    KeyDate,
    IconCount,
    StatusChip,
    TooltipedText,
    GroupOfAccreditationMenu,
    GroupOfAccreditationStateChips
  },
  filters: {
    firstUpperCase(val) {
      return val[0].toUpperCase() + val.slice(1)
    }
  },
}
</script>
<style scoped lang="scss">
</style>